import React from 'react';
import HomepageHub from '../components/homepage/HomepageHub';
import NewReferencesSection from '../components/homepage/NewReferencesSection';

const Homepage = () => {
  return (
    <div className="homepage font-body overflow-x-hidden">
      <HomepageHub />
      <NewReferencesSection />
    </div>
  );
};

export default Homepage;
